/* NEWSLETTER POPUP 起動
---------------------------------------------------------- */
$('button[class*="c-button-def"][class*="-nl"]').on("click", function () {
  var $target = $('div[id*="__newsletter-popup"] .newsletter-popup');
  $target.attr("open", "");
  $target.css({ display: "block", opacity: 1, transform: "translateY(0px)" });
});

/* クイックビュー
  ---------------------------------------------------------- */
$(document).on("click", function (e) {
  var $btnQvOpen = $('*[class*="c-button-quickView"]');
  var $btnQvClose = $(".c-quickViewBlock .c-button-close");
  var $targetQvSection = $btnQvClose.closest(
    'section[class*="l-quickviewSection"]'
  );
  if ($(e.target).closest($btnQvOpen).length) {
    var $thisBtn = $(e.target).closest($btnQvOpen);
    var $targetQvOpen = $("#" + $thisBtn.attr("data-quickview-id"));
    $targetQvOpen.addClass("l-quickviewSection--active");
    $("body").addClass("l-overlaySection--active");
    $("html").addClass("lock");
  } else if (
    !$(e.target).closest($targetQvSection).length &&
    $targetQvSection.hasClass("l-quickviewSection--active")
  ) {
    $targetQvSection.removeClass("l-quickviewSection--active");
    $("body").removeClass("l-overlaySection--active");
    $("html").removeClass("lock");
  } else if (
    $(e.target).closest($btnQvClose).length &&
    $targetQvSection.hasClass("l-quickviewSection--active")
  ) {
    $targetQvSection.removeClass("l-quickviewSection--active");
    $("body").removeClass("l-overlaySection--active");
    $("html").removeClass("lock");
  }
});
